import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const DEFAULT_EXPAND_ICON = ExpandMoreIcon;
